package com.gastoncantera.intercom.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.gastoncantera.intercom.call.CallError
import com.gastoncantera.intercom.call.friendlyMessage

/**
 * Mensaje amable de error de llamada + botón para resolver el permiso (cuando aplica).
 * [withVideo] hace que el texto sea acorde al modo (portero: mic + cámara; usuario: solo mic).
 * [onResolved] se llama cuando el permiso queda concedido, para limpiar el error.
 */
@Composable
fun CallErrorBanner(
    error: CallError,
    withVideo: Boolean,
    onResolved: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(4.dp),
    ) {
        Text(
            error.friendlyMessage(withVideo),
            color = MaterialTheme.colorScheme.error,
            style = MaterialTheme.typography.bodySmall,
            textAlign = TextAlign.Center,
        )
        if (error == CallError.PermissionDenied) {
            rememberMediaPermissionAction(withVideo, onResolved)?.let { action ->
                TextButton(onClick = action, modifier = Modifier.padding(top = 2.dp)) {
                    Text(if (withVideo) "Permitir cámara y micrófono" else "Permitir micrófono")
                }
            }
        }
    }
}
